import { css } from '@emotion/react';
import { DataCard } from '../../../../components/Card/DataCard';
import { FMT } from '../../../../util/formatter-service';
import { IEquityTotals } from './equity-holdings-model';

/** Seven tiles across, wrapping on narrow containers. */
const list = css`
  display: grid;
  gap: 0.5rem;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  list-style: none;
  margin: 0;
  padding: 0 0.5rem 0.75rem;
`;

interface IEquityHoldingsKpisProps {
  totals: IEquityTotals;
}

/** Tile order follows the design: ownership, shares, invested, proceeds, FMV, MOIC, lots. */
export function EquityHoldingsKpis({ totals }: IEquityHoldingsKpisProps) {
  return (
    <ul css={list}>
      <DataCard
        title='Current Ownership'
        formattedValue={FMT.format('percent', totals.ownershipPct)}
      />
      <DataCard
        title='Shares Outstanding'
        formattedValue={FMT.format('numericShort', totals.shares)}
      />
      <DataCard title='Total Invested' formattedValue={FMT.format('currencyShort', totals.invested)} />
      <DataCard title='Proceeds' formattedValue={FMT.format('currencyShort', totals.proceeds)} />
      <DataCard title='FMV' formattedValue={FMT.format('currencyShort', totals.fmv)} />
      <DataCard title='MOIC' formattedValue={FMT.format('multiplier', totals.moic)} />
      <DataCard title='Active Lots' formattedValue={FMT.format('integer', totals.activeLotCount)} />
    </ul>
  );
}
